import React, { useState, useEffect } from 'react';
import { FormGroup, Form, Dropdown } from 'semantic';
import { useTranslation } from 'react-i18next';
import CardStyleRadioButton from 'components/form-fields/CardStyleRadioButton';
import { DropdownOption } from 'subdomains/cpo/types/charging-policy';
import { ChargingGroupPreview } from 'subdomains/cpo/screens/GroupsAndPolicies/ChargingGroups/ChargingGroupPreview';

type Props = {
  values?: string[];
  onChange?: (values: string[]) => void;
};

const ChargingPolicyAssociationSelection: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const [isAllSelected, setIsAllSelected] = useState(!props.values?.length);
  const [selectedChargingGroups, setSelectedChargingGroups] = useState<
    string[]
  >(props.values || []);

  useEffect(() => {
    if (isAllSelected) {
      props.onChange?.([]);
    } else if (selectedChargingGroups.length > 0) {
      props.onChange?.(selectedChargingGroups);
    }
  }, [isAllSelected, selectedChargingGroups]);

  const handleModeChange = (isAll: boolean) => {
    if (isAll != isAllSelected) {
      setSelectedChargingGroups([]);
    }

    setIsAllSelected(isAll);
  };

  // TODO: needs to become API req
  function getChargingGroupOptions(): DropdownOption[] {
    return [
      {
        key: 'CHARGING_GROUP_1',
        text: 'Charging Group 1',
        value: 'CHARGING_GROUP_1',
      },
    ];
  }

  return (
    <>
      <FormGroup style={{ marginLeft: '0', marginRight: '0' }}>
        <CardStyleRadioButton
          isSelected={isAllSelected}
          onClick={() => handleModeChange(true)}
          text={t(
            'chargingPolicy.association.allChargingStationsButton',
            'All Charging Stations'
          )}
        />
        <CardStyleRadioButton
          isSelected={!isAllSelected}
          onClick={() => handleModeChange(false)}
          text={t(
            'chargingPolicy.pricing.chargingGroupsButton',
            'Charging Groups'
          )}
        />
      </FormGroup>
      {!isAllSelected && (
        <Form.Field required>
          <label>
            {t(
              'chargingPolicy.pricing.selectChargingGroups',
              'Select Charging Groups'
            )}
          </label>
          <Dropdown
            selection
            multiple
            value={selectedChargingGroups}
            options={getChargingGroupOptions()}
            onChange={(
              _: React.SyntheticEvent,
              { value }: { value: string[] }
            ) => setSelectedChargingGroups(value)}
          />
        </Form.Field>
      )}
      {selectedChargingGroups.map((group) => (
        // TODO: get the actual name of the group from API
        <ChargingGroupPreview
          values={{ name: group }}
          key={group}
          onEdit={() => {}}
          onRemove={() => {}}
        />
      ))}
    </>
  );
};

export default ChargingPolicyAssociationSelection;
